import React from "react";
import { useTranslation } from "react-i18next";
import labelHelper from "../../utils/helpers/labelHelper";

function LegendItem(props) {
  const { t } = useTranslation();

  const isReservedFilter = props.type === "RESERVED";
  const labelText = props.hotspots[props.type].text;

  return (
    <div
      className="legend-row"
      style={{
        height: `${
          props.availableFilters
            ? 100 / (props.availableFilters.length + 1)
            : 20
        }%`,
        display: `${
          props.availableFilters?.includes(props.type) ? "flex" : "none"
        }`,
      }}
    >
      <div className="legend-item">
        {" "}
        <div
          className={`${props.type.toLowerCase()}-icon`}
          style={{
            backgroundColor: isReservedFilter ?
              props.apartmentReservedColor :
              props.hotspots[props.type].defaultColor,
          }}
        ></div>{" "}
      </div>
      <div className="legend-item">
        <p>{labelText || t(props.type)}</p>
        {!isReservedFilter && !labelText ? (
          <p>
            {t("APARTMENT")} <br /> {labelHelper.getHotspotLongTypeTranslation(props.type)}
          </p>
        ) : null}
      </div>
    </div>
  );
}

export default LegendItem;
